import { useEffect, useState } from 'react';
import {
  fetchPriestOrdersAPI,
  fetchCateringOrdersAPI,
  fetchTentOrdersAPI
} from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch } from 'react-redux';
import { addServiceToOrder, clearEntireOrder } from '../store/cartbodydataslice';

export const useOrders = () => {
  const [orderLoading, setOrderLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchOrders = async () => {
      setOrderLoading(true);
      try {
        clearEntireOrder();

        //priest Orders
        const priestResponse = await fetchPriestOrdersAPI();

        const result = priestResponse?.result || [];

        result.forEach((eventItem) => {
          const eveId = eventItem.event_id;;
          const eventName = eventItem.event_title;
          eventItem.priestItems.forEach((priestItem) => {
            const is_checked_out = priestItem.is_checked_out
            const balance_to_be_paid = priestItem.balance_to_be_paid;
            const paid_amount = priestItem.paid_amount;
            const is_edit_allowed = priestItem.is_edit_allowed;
            const provider = priestItem.priest;
            const pricing = priestItem.pricing;
            const order_id = priestItem.id
            dispatch(
              addServiceToOrder({
                eveId,
                eventname: eventName,
                type: 'priestData',

                item: {
                  ...priestItem,
                  is_checked_out: is_checked_out,
                  is_edit_allowed: is_edit_allowed,
                  paid_amount: paid_amount,
                  balance_to_be_paid: balance_to_be_paid,

                  is_cancel_in_progress: priestItem.is_cancel_in_progress,
                  is_canceled: priestItem.is_canceled,
                  refund_complete: priestItem.refund_complete,
                  refund_in_pending: priestItem.refund_in_pending,
                  refunded_amount: priestItem.refunded_amount,

                  provider_id: provider.id,
                  providername: provider.name,
                  price: pricing.price,
                  discountPrice: pricing.discountPrice,
                  validUpto: pricing.discountValidUpto,
                  gstAmount: pricing.gstAmount,
                  gstPercentage: pricing.gstPercentage,
                  totalAmount: pricing.totalAmount,
                  service_id: priestItem.service.id,
                  order_id: order_id,
                  mobileNumber: provider.mobileNumber
                },
              })
            );
          });
        });


        //Catering Orders

        const cateringResponse = await fetchCateringOrdersAPI();

        cateringResponse.data.forEach((orderitem) => {
          const eveId = orderitem.event_id;
          const eventname = orderitem.event_title;
          const event_start_date = orderitem.event_start_date
          orderitem.catering_providers.forEach((cateringitem) => {
            const dispatchPayload = {
              eveId,
              eventname: eventname,
              event_start_date: event_start_date,
              type: "cateringData",
              item: {
                ...cateringitem,
                provider_id: cateringitem.provider_id,
                balance_to_be_paid: cateringitem.balance_to_be_paid,
                is_checked_out: cateringitem.is_checked_out,
                is_edit_allowed: cateringitem.is_edit_allowed,
                paid_amount: cateringitem.paid_amount,
                providername: `${cateringitem.first_name} ${cateringitem.last_name}`,
                services: cateringitem.items.map((item) => ({
                  ...item,
                  mapping_id: item.item_id,
                  service_id: item.category_id,
                  quantity: item.number_of_people,
                  price: item.regular_price,
                  discountPrice: item.discounted_price,
                  gst_amount: item.gst_amount,
                  gst_percentage: item.gst_percentage,
                  total_amount: item.total_amount,
                  validUpto: item.valid_until,
                  category: item.category.name,
                  mealtype: item.meal.name,
                  cuisine: item.type.name
                })),
              },
            };

            try {
              dispatch(addServiceToOrder(dispatchPayload));
            } catch (dispatchErr) {
              console.error("Dispatch Error (addServiceToOrder):", dispatchErr);
              console.log("Failed Dispatch Payload:", dispatchPayload);
            }
          });
        });



        //tent Orders
        const response = await fetchTentOrdersAPI();

        response.data.forEach((orderitem) => {
          const eveId = orderitem.event_id;
          const eventname = orderitem.event_title;
          const event_start_date = orderitem.event_start_date
          orderitem.tent_providers.forEach((tentitem) => {
            const provider = tentitem;
            const pricingData = provider.pricing || {};
            dispatch(
              addServiceToOrder({
                eveId,
                eventname: eventname,
                event_start_date: event_start_date,
                type: 'tentHouseData',
                item: {
                  ...tentitem,
                  provider_id: provider.provider_id,
                  balance_to_be_paid: provider.balance_to_be_paid,
                  is_checked_out: provider.is_checked_out,
                  is_edit_allowed: provider.is_edit_allowed,
                  paid_amount: provider.paid_amount,
                  providername: (provider.first_name ?? "") + ' ' + (provider.lastName ?? ""),
                  services: tentitem.items.map((item) => ({
                    ...item,
                    order_id: item.order_id,
                    mapping_id: item.mapping_id,
                    service_id: item.service_id,
                    quantity: item.quantity,
                    price: item.price,
                    discountPrice: item.discount_price,
                    validUpto: item.discount_valid_upto,
                  }))
                },
              })
            );
          });
        });


  

      } catch (err) {
        console.error('Error loading tent order:', err);
      }
      setOrderLoading(false);
    };

    fetchOrders();
  }, [refreshTrigger]);

  const fetchAllOrders = () => setRefreshTrigger((prev) => prev + 1);

  const clearOrders = () => clearEntireOrder();

  return {
    fetchAllOrders,
    clearOrders,
  };
};
